import { render, staticRenderFns } from "./PublicRIDC.vue?vue&type=template&id=60068518&scoped=true&"
import script from "./PublicRIDC.vue?vue&type=script&lang=ts&"
export * from "./PublicRIDC.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60068518",
  null
  
)

export default component.exports